<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择车辆"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      :handleSearchData="handleSearchData"
      @change="handleResultChange"
      :customShow="customShow"
      :showName="showName"
      :clearable="clearable"
      :disabled="disabled"
    >
      <section slot="tableSlot" slot-scope="scope">
        {{scope.row[scope.column.property]}}
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  annualReviewCarList,
} from 'api/car';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showName: 'plateNumber',
      tableSelectTar: 'plateNumber',
      searchBoxDataTmpl: {
        form: [
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号码',
        },
      ],
      tableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号码',
        },
        {
          prop: 'licenceTypeName',
          label: '证照类型',
        },
        {
          prop: 'vehicleInfo',
          label: '车型',
        },
        {
          prop: 'orgName',
          label: '归属部门',
        },
      ],
    };
  },
  methods: {
    getListApi: annualReviewCarList,
    handleSearchData (searchBoxData) {
      searchBoxData.moreInfo = true;
      return searchBoxData;
    },
    handleResultChange (val) {
      this.$emit('change', val);
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
};
</script>

<style>

</style>
